export default "__VITE_ASSET__CTv0RES0__"